<div class="cursor-pointer document-preview-container" [ngClass]="item.fileType === FILE_TYPE.IMAGE ? 'preview-image' : 'preview-file'" [matTooltip]="item.fileName">
  <div class="d-flex justify-content-center" [ngClass]="item.fileType === FILE_TYPE.IMAGE ? 'preview-image-wrapper' : 'preview-file-wrapper'">
    @switch (item.fileType) {
      @case (FILE_TYPE.PDF) {
        <img src="global-assets/mobi-office-ui/file-icons/pdf.png" class="icon" (click)="onViewDocument()" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.EXCEL) {
        <img src="global-assets/mobi-office-ui/file-icons/csv.png" class="icon" (click)="onViewDocument()" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.VIDEO) {
        <img src="global-assets/mobi-office-ui/file-icons/mp4.png" class="icon" (click)="onViewDocument()" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.AUDIO) {
        <img src="global-assets/mobi-office-ui/file-icons/mp3.png" class="icon" (click)="onViewDocument()" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.DOC) {
        <img src="global-assets/mobi-office-ui/file-icons/doc.png" class="icon" (click)="onViewDocument()" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.TEXT) {
        <img src="global-assets/mobi-office-ui/file-icons/txt.png" class="icon" (click)="onViewDocument()" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.ZIP) {
        <img src="global-assets/mobi-office-ui/file-icons/zip.png" class="icon" (click)="onViewDocument()" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.RAR) {
        <img src="global-assets/mobi-office-ui/file-icons/rar.png" class="icon" (click)="onViewDocument()" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.GZ) {
        <img src="global-assets/mobi-office-ui/file-icons/gz.png" class="icon" (click)="onViewDocument()" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.PPT) {
        <img src="global-assets/mobi-office-ui/file-icons/ppt.png" class="icon" (click)="onViewDocument()" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.XML) {
        <img src="global-assets/mobi-office-ui/file-icons/xml.png" class="icon" (click)="onViewDocument()" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.JSON) {
        <img src="global-assets/mobi-office-ui/file-icons/json-file.png" class="icon" (click)="onViewDocument()" [alt]="item.fileName" />
      }
      @case (FILE_TYPE.SQL) {
        <img src="global-assets/mobi-office-ui/file-icons/sql.png" class="icon" (click)="onViewDocument()" [alt]="item.fileName" />
      }
      @default {
        <img [src]="item?.fileUrl" class="icon w-100" (click)="onViewDocument()" (error)="setDefaultImage($event)" [alt]="item.fileName" />
      }
    }
  </div>
</div>
